
import { defineComponent } from "vue";
import { Dark } from "quasar";

export default defineComponent({
  name: "BtnModal",
  components: {},
  props: {
    btnProps: Object,
    dialogProps: Object,
    dialogVisible: Boolean,
  },
  emits: ["update:dialog-visible", "hide"],
  data() {
    return {
      visible: this.dialogVisible,
    };
  },
  computed: {
    btnPropsComputed(): any {
      return {
        flat: true,
        noCaps: true,
        label: undefined,
        ...this.btnProps,
      };
    },
    dialogPropsComputed(): any {
      return {
        title: undefined,
        fullHeight: true,
        ...this.dialogProps,
      };
    },
    card_class() {
      return {
        "bg-white": !Dark.isActive,
        "bg-dark": Dark.isActive,
      };
    },
  },
  watch: {
    dialogVisible() {
      this.visible = this.dialogVisible;
    },
  },
  methods: {
    showDialog() {
      this.visible = !this.visible;
      this.$emit("update:dialog-visible", this.visible);
    },
    hideDialog() {
      this.$emit("hide");
      this.$emit("update:dialog-visible", this.visible);
    },
  },
});
